import React from "react";
import { Link } from "react-router-dom";
import { UserPlus, MousePointerClick, Share2, ArrowRight, BadgeCheck } from "lucide-react";
import { ARAC_TOOLS } from "./Header";

const STEPS = [
  { icon: UserPlus, title: "Ücretsiz üye olun", desc: "Ad, şehir ve telefonunuzla 30 saniyede hesabınızı açın." },
  { icon: MousePointerClick, title: "Aracınızı seçin", desc: "Davetli listesi, bütçe, ajanda, oturma planı... ihtiyacınız olanı açın." },
  { icon: Share2, title: "Planlayın ve paylaşın", desc: "Bilgileriniz kaydedilir; davetiyenizi WhatsApp'tan tek mesajla gönderin." },
];

export const FreeToolsSection = () => (
  <section className="relative bg-[#FBF5F0] py-20 overflow-hidden" data-testid="free-tools-section">
    <div className="max-w-7xl mx-auto px-5 grid lg:grid-cols-[1fr_1.15fr] gap-12 items-start">
      <div>
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#E6F4EA] text-[#2f7d4f] text-xs font-semibold tracking-wide" data-testid="free-tools-badge">
          <BadgeCheck className="w-4 h-4" /> %100 ÜCRETSİZ
        </span>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-[#2A2224] mt-4 leading-tight">
          Düğün planlama araçları <span className="text-[#9E2A3B]">tamamen ücretsiz</span>
        </h2>
        <p className="text-[#7C6E70] mt-4 max-w-md">Hiçbir ücret, kart bilgisi veya gizli ödeme yok. Üye olun, tüm araçları sınırsız kullanın.</p>

        <ol className="mt-8 space-y-5">
          {STEPS.map((s, i) => (
            <li key={s.title} className="flex gap-4 animate-fade-up" style={{ animationDelay: `${i * 0.1}s` }} data-testid={`free-tools-step-${i + 1}`}>
              <span className="relative shrink-0 w-12 h-12 rounded-xl bg-white border border-[#F0DDE0] flex items-center justify-center text-[#9E2A3B]">
                <s.icon className="w-5 h-5" />
                <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[#C6A15B] text-white text-xs font-bold flex items-center justify-center">{i + 1}</span>
              </span>
              <div>
                <p className="font-semibold text-[#2A2224]">{s.title}</p>
                <p className="text-sm text-[#7C6E70] mt-0.5">{s.desc}</p>
              </div>
            </li>
          ))}
        </ol>

        <Link to="/araclar" data-testid="free-tools-cta" className="inline-flex items-center gap-2 mt-9 px-6 py-3 rounded-full bg-[#9E2A3B] text-white font-medium hover:bg-[#861f2f] transition-colors">
          Hemen Ücretsiz Başla <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {ARAC_TOOLS.filter((t) => t.key !== "favorilerim").map((t, i) => (
          <Link key={t.key} to={`/araclar?arac=${t.key}`} data-testid={`free-tool-card-${t.key}`}
            className="group bg-white rounded-2xl border border-[#F0DDE0] p-5 hover:border-[#C15B6B] hover:-translate-y-1 transition-[transform,border-color] duration-300 animate-fade-up"
            style={{ animationDelay: `${i * 0.06}s` }}>
            <span className="w-11 h-11 rounded-full flex items-center justify-center bg-[#FBF5F0] text-[#C15B6B] group-hover:bg-[#9E2A3B] group-hover:text-white transition-colors">
              <t.icon className="w-5 h-5" />
            </span>
            <p className="font-semibold text-[#2A2224] mt-3 text-sm">{t.label}</p>
            <p className="text-xs text-[#7C6E70] mt-1 leading-relaxed">{t.desc}</p>
            <span className="inline-block mt-3 text-[10px] font-semibold tracking-wider text-[#2f7d4f]">ÜCRETSİZ</span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);
